import fetch from '@/common/axios';
export const ACCOUNT = '//account.wps.cn';
import md5 from 'js-md5';

/**
 * 获取用户账号信息
 */
export const queryUserInfo = async() => {
  let finalData = null

  try {
    const result = await fetch.post('https://account.wps.cn/p/auth/check',)
    finalData = result
    window.dw.setAccountId(md5('' + finalData.userid));
  } catch (e) {
    console.log("获取用户账号信息失败", e)
    if (e.result === "userNotLogin") {
      window.dw.setAccountId('');
    }
  }

  return finalData
}

// 退出登录
export const logout = () => {
  return fetch.post(`//account.wps.cn/p/logout`, {
      timestamp: +new Date()
  });
};
